import request from '@/network/request'

// 暨南大学患者信息查询
export function gzhGetPatientCaseHistory(data) {
  return request({
    url: '/sclm/apply/app/scanJinan/gzhGetPatientCaseHistory',
    method: 'post',
    data,
  })
}

// 暨南大学订单分页
export function gzhOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanJinan/gzhOrderPage',
    method: 'post',
    data,
  })
}

// 暨南大学订单详情
export function gzhOrderInfo(data) {
  return request({
    url: '/sclm/apply/app/scanJinan/gzhOrderInfo',
    method: 'post',
    data,
  })
}
// 平遥订单数据
export function orderPage(data) {
  return request({
    url: '/sclm/apply/app/scanPingYao/orderPage',
    method: 'post',
    data,
  })
}
// 长沙太和订单数据
export function changshataiheOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanChangShaTaiHe/orderPage',
    method: 'post',
    data,
  })
}
// 山西医科大订单数据
export function yikedaOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanSxykdxdy/orderPage',
    method: 'post',
    data,
  })
}
// 高陵订单记录
export function gaolingOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanXiangaolingqu/orderPage',
    method: 'post',
    data,
  })
}
// 凤城订单数据
export function fengchengOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanFengCheng/orderPage',
    method: 'post',
    data,
  })
}
// 省人民订单数据
export function srmOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanSxsrm/orderPage',
    method: 'post',
    data,
  })
}
// 杏花岭中心医院订单数据
export function xhlzxOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanXinghualingzhongxin/orderPage',
    method: 'post',
    data,
  })
}
// 泰兴二院订单数据
export function taixingOrderPage(data) {
  return request({
    url: '/sclm/apply/app/scanTaiXingErYuan/orderPage',
    method: 'post',
    data,
  })
}
